import styled from "styled-components";
import { subText, extendedSystemStyles } from "@mixins";
var styledSystemKeys = ["space", "layout", "flexbox", "colors"];
export default styled.p.withConfig({
  displayName: "ErrorMessage",
  componentId: "sc-3kamed-0"
})(["", "", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    ".concat(subText(theme), "\n    color: ").concat(theme.colors.V3, ";\n    margin: 10px 0;");
}, extendedSystemStyles(styledSystemKeys));